export default __webpack_public_path__ + "static/wave-dots-d68e36dc11ecd2e39fa0596148c02766.svg";